import { render, staticRenderFns } from "./AddBlackListUserComponent.vue?vue&type=template&id=915d8db8"
import script from "./AddBlackListUserComponent.vue?vue&type=script&lang=js"
export * from "./AddBlackListUserComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports